import { render } from "./OrderSect.vue?vue&type=template&id=2b9bc3e6&ts=true"
import script from "./OrderSect.vue?vue&type=script&lang=ts"
export * from "./OrderSect.vue?vue&type=script&lang=ts"

import "./OrderSect.vue?vue&type=style&index=0&id=2b9bc3e6&lang=scss"

import exportComponent from "/Users/damodar/Documents/PROGRAMMING/STUDING/everypay/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__